import { Api } from "../config/request";

export const getPayoutList = (rideId) => {
    try {
        const response = Api.getRequest(`payout/${rideId}`);
        return response;
    } catch (error) {
        console.error("Error fetching payout list:", error);
        throw error;
    }

};


export const addPayout = async (payoutData) => {
    try {
        const response = await Api.postRequest('payout', payoutData);
        return response;
    } catch (error) {
        if (error.response) {
            console.error("Error response:", error.response.data);
        }
        throw new Error(error.message || 'Failed to add payout');
    }
};

const PayoutAPI = {
    getPayoutList,
    addPayout,
};

export default PayoutAPI;
